import type {AccountManagerInfo} from 'src/openapi/admin/models/AccountManagerInfo';

export const movePrimaryAccountManagerToEnd = (am: Array<AccountManagerInfo>) => {
    const amCopy = [...am];
    const primary = amCopy.shift();

    return primary ? [...amCopy, primary] : am;
};
